import * as React from 'react';
import {Radio, view} from '@sail/ui';

export const Uncontrolled = () => {
  return (
    <view.div
      css={{
        layout: 'column',
      }}
    >
      <Radio
        name="group1"
        label="Have some of Column A"
        onChange={(e) => {
          console.log(e.target.checked);
        }}
      />
      <Radio
        name="group1"
        label="Try all of Column B"
        onChange={(e) => {
          console.log(e.target.checked);
        }}
      />
    </view.div>
  );
};
